module.exports = "<ram-page [autoscale]=\"true\"></ram-page>"